import React from 'react';
import LearnCard from "./LearnCard";
import { v4 as uuidv4 } from 'uuid';

import { useSelector } from "react-redux";
import { Animate } from "react-simple-animate";

import stripHtml from "../../Components/StripHTML";

import LearnOffCanvas from "./LearnOffCanvas";

export default function Learn(props) {

    const { learns } = useSelector((state) => state.learns)


    const { learnOffCanvasIsActive } = useSelector((state) => state.navBar)

    return (
        <>

            {learnOffCanvasIsActive ? <LearnOffCanvas/> :

                <div className="grid sm:grid-cols-2 2xl:grid-cols-3 gap-y-4 watch h-full bg-purple-dashboard overflow-y-scroll items-center ">

                    {learns && learns.map((learn) =>
                        <Animate play start={{ opacity: 0 }} end={{ opacity: 1 }} key={uuidv4()} duration={0.7}>
                            <LearnCard
                                imgSrc={learn?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ?? null}
                                duration={0.7}
                                favourite={false}
                                title={stripHtml(learn?.title?.rendered ?? "")}
                                text={learn?.content?.rendered ?? ""}
                                // vidLink={learn?.acf?.video_url ?? null}
                                vidLink={learn?.acf?.video_network === "vimeo" ? learn?.acf?.vimeo_url ?? null : learn?.acf?.youtube_url ?? null}
                                mediaType={learn?.type ?? null}
                                mediaId={learn?.id ?? null}
                            />
                        </Animate>
                    )}
                </div>

            }
    </>
    );
}